enum TearHorizontalPosition {
  Leading = "Leading",
  Trailing = "Trailing",
}

export default TearHorizontalPosition
